import { Flows } from '../flows/flows';
import type { AllFlows } from '../types/flows/AllFlows';

/* Please refrain from using the following constant within any of the Authentication views to avoid the dependency cycle */
export const flowsURLParameters = Object.keys(Flows).reduce(
  (flows, flowName) => ({ ...flows, [flowName]: flowName }),
  {},
) as Record<keyof Pick<AllFlows, 'login'>, string>;
